var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtHdarkgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 4V9.91332L16.9965 12.1466L11.9985 4Z",
    fill: "#525F6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 4L7 12.1466L11.9987 9.91332V4Z",
    fill: "#525F6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 15.9785V19.9965L16.9999 13.0771L11.9985 15.9785Z",
    fill: "#525F6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 19.9965V15.9778L7 13.0771L11.9987 19.9965Z",
    fill: "#525F6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 15.049L16.9965 12.147L11.9985 9.91504V15.049Z",
    fill: "#525F6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.147L11.9987 15.049V9.91504L7 12.147Z",
    fill: "#525F6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtHdarkgrey);
export default __webpack_public_path__ + "static/media/ETHdarkgrey.f790492a1b46e0fa6188443e3934a608.svg";
export { ForwardRef as ReactComponent };